module.exports = __webpack_public_path__ + "img/Stoeckelschuhe.4f7525ac.png";